import './tablero.scss';
import template from './tablero.html';
import commonI18N from 'i18n/common/es.json';
import procesarTemplate from './procesar.html';
import { rest } from 'core/api';
import { fullscreen } from 'core/util';

// MODULE EXPORTS
export let TableroComisionesComponent = {
  templateUrl: template,
  selector: 'tableroComisiones',
  bindings: {
    translations: '='
  },
  controller: TableroCtrl,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(commonI18N);

TableroCtrl.$inject = ['$ngRedux', '$state', 'Filter', 'CustomModal', 'ngNotify', 'AuthorizationService', '$timeout'];


function TableroCtrl($ngRedux, $state, Filter, CustomModal, ngNotify, AuthorizationService, $timeout) {
  Object.assign(this, { $ngRedux, $state });
  this.mapStateToThis = mapStateToThis.bind(this);
  this.renderEspecialista = renderEspecialista.bind(this);

  this.fullscreen = () => { $timeout(() => fullscreen()); };
  this.procesar = procesar.bind(this);
  this.clearComisiones = clearComisiones.bind(this);

  let filterEspecialistas = Filter.path('tipoEmpleado.value').eq('Especialista').and(Filter.path('activo').eq(true));

  this.localModel = {
    empleados: [],
    mostrarComisiones: false,
    totalDetalles: 0
  };

  let unsubscribe;
  this.$onDestroy = () => {
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, {})(this);
    $ngRedux.dispatch(rest.actions.empleados({ filter: JSON.stringify(filterEspecialistas) }));
  };

  function mapStateToThis(state) {

    if (state.empleados.data && state.empleados.data.length > 0 && !this.localModel.empleados.length) {
      this.localModel.empleados = state.empleados.data;
    }

    return {};
  }

  function renderEspecialista(empleado) {
    return `${empleado.nombre} ${empleado.apellido}`;
  }

  function clearComisiones() {
    this.localModel.mostrarComisiones = false;
  }

  this.renderDescuentoProcesadora = renderDescuentoProcesadora.bind(this);

  function renderDescuentoProcesadora(detalle) {
    if (!detalle.procesadora) return 0;
    let n = 0;

    if (detalle.importeNeto && detalle.facturaDetalle) {
      n = (detalle.importeNeto - detalle.facturaDetalle.descuento) * detalle.procesadora.porcentaje / 100;
    } else if (detalle.facturaDetalle) {
      n = (detalle.facturaDetalle.precio - detalle.facturaDetalle.descuento - detalle.facturaDetalle.iva5 - detalle.facturaDetalle.iva10) * detalle.procesadora.porcentaje / 100;
    }

    return n;
  }


  this.renderMontoNeto = renderMontoNeto.bind(this);

  function renderMontoNeto(detalle) {

    let n = 0;
    if (detalle.importeNeto) {
      n = detalle.importeNeto - (detalle.facturaDetalle ? detalle.facturaDetalle.descuento : 0);
    } else if (detalle.facturaDetalle) {
      n = detalle.facturaDetalle.precio - detalle.facturaDetalle.descuento - detalle.facturaDetalle.iva5 - detalle.facturaDetalle.iva10;
    }
    return n;
  }

  this.renderMontoNetoSinProcesadora = renderMontoNetoSinProcesadora.bind(this);

  function renderMontoNetoSinProcesadora(detalle) {
    let descuentoProcesadora = renderDescuentoProcesadora(detalle);
    let importeNeto = renderMontoNeto(detalle);

    return importeNeto - descuentoProcesadora;
  }


  function procesar(empleado) {
    let self = this;
    this.empleado = empleado;
    this.localModel.payload = {
      empleadoId: empleado.id
    };

    if (AuthorizationService.hasPermission('index_comision_especialista')) {
      $ngRedux.dispatch(rest.actions.recuperarComisiones({}, {
        body: JSON.stringify(self.localModel.payload)
      }, (err, data) => {
        if (!err) {
          self.localModel.mostrarComisiones = true;
          self.localModel.comisiones = data;
          let total = 0;
          self.localModel.comisiones.forEach(function(detalle) {
            total += detalle.importe;
          });
          self.localModel.totalDetalles = total;
        } else if (err) {
          ngNotify.set(err.message, 'warn');
        }
      }));
    } else {
      CustomModal.open({
        title: 'Recuperar Comisiones',
        templateUrl: procesarTemplate,
        empleado: this.model,
        payload: this.localModel.payload,
        messageClass: 'font-large',
        headerClass: 'font-large',
        ok: function() {
          $ngRedux.dispatch(rest.actions.recuperarComisiones({}, {
            body: JSON.stringify(self.localModel.payload)
          }, (err, data) => {
            if (!err) {
              self.localModel.mostrarComisiones = true;
              self.localModel.comisiones = data;
              let total = 0;
              self.localModel.comisiones.forEach(function(detalle) {
                total += detalle.importe;
              });
              self.localModel.totalDetalles = total;
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
        }
      });
    }
  }



}


// WEBPACK FOOTER //
// ./src/components/tablero-comisiones/tablero.component.js